<template>
  <div class="swiper-detail">
    <common-head />
    <div class="my-wrap">
      <div class="my-html" v-html="content"></div>
    </div>
    <!-- <div class="my-button" v-if="content">
      <van-button type="info" round @click="enterAppointment">去预约</van-button>
    </div> -->
  </div>
</template>

<script>
import CommonHead from 'components/CommonHead'
import { fetchBannerDetail } from 'api/home'

export default {
  components: {
    CommonHead
  },
  data() {
    return {
      content: ''
    }
  },
  created() {
    this.getDetail()
  },
  methods: {
    // 获取轮播图详情
    getDetail() {
      const { id } = this.$route.query
      fetchBannerDetail(id).then(res => {
        this.content = res.data.content
      })
    },
    enterAppointment() {
      this.$router.push('/appointment')
    }
  }
}
</script>

<style lang="less" scoped>
.swiper-detail {
  padding-bottom: 81px;
}
</style>